import moment from 'moment'

export default {
   locale: "en",
	formats: {
		"date-time": function(e,t) {
         return moment(new Date(e)).format('DD/MM/YYYY h:mm:ss A')
      },
      "date": function(e,t) {
         return moment(new Date(e)).format('DD/MM/YYYY')
      }
   },
   "rules": {},
   "messages": {
      required: "This field is required",
      noData: 'No matching value found',
      search: 'Search...',
      minimum: 'Value must be more than {minimum}',
      maximum: 'Value must be less than {maximum}',
      minLength: '{minLength} characters minimum',
      maxLength: '{maxLength} characters maximum',
      minItems: 'No less than {minItems} items',
      maxItems: 'No more than {maxItems} items',
      pattern: 'The expected pattern is not satisfied'
   },
   "editMode": "inline",
}
